<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        block
        color="red darken-1"
        class="white--text"
        dark
        v-bind="attrs"
        v-on="on"
      >
        Delete Selected
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Delete lead</span>
      </v-card-title>
      <v-card-text>Are you sure want to delete this lead?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="red darken-1" class="white--text" @click="deleteSelected">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "DeleteSelectedForm",
  data() {
    return {
      open: false,
    };
  },
  methods: {
    ...mapMutations({
      SET_SELECTED_POOL: "leads/SET_SELECTED_POOL",
    }),
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    deleteSelected() {
      if (this.selectedPool.length == 0) {
        this.showHandlerSnackbar({
          color: "red",
          text: "Please select the leads to be able delete it!",
          show: true,
        });
      } else {
        this.$axios
          .post("/lead/delete-selected", { leads: this.selectedPool })
          .then((res) => {
            this.open = false;
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
            this.SET_SELECTED_POOL([]);
          })
          .catch((err) => {
            this.showHandlerSnackbar({
              color: err.data.status,
              text: err.data.message,
              show: true,
            });
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      selectedPool: "leads/selectedPool",
    }),
  },
};
</script>
